<template>
  <div class="card">
    <div class="card-header text-center py-2" id="formPro">{{ titulo }}</div>
    <div class="card-body" v-if="verForm">
      <div v-if="verFormImagen">
        <h5 class="text-center mb-4">Imágenes de {{ producto.nombre }}</h5>
        <form @submit.prevent="guardarImagen">
          <div class="form-group row mb-1">
            <label for="inputArchivo" class="col-sm-1 col-form-label">Archivo:</label>
            <div class="col-sm-7">
              <div class="custom-file">
                <input type="file" class="custom-file-input" id="inputImagen" @change="setImagen" accept="image/x-png,image/gif,image/jpeg">
                <label class="custom-file-label" for="inputImagen" data-browse="Buscar">
                  {{ imagen ? imagen.name : 'Seleccione una imágen'}}
                </label>
              </div>
              <small id="inputArchivo" class="form-text text-muted">El archivo debe ser menor a 1 MB.</small>
            </div>

            <div class="col-sm-2">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="inputPrincipal"
                  v-model="principal"
                  true-value="1"
                  false-value="0">
                <label class="form-check-label" for="inputPrincipal">
                  Principal
                </label>
              </div>
            </div>
            <div class="col-sm-2">
              <button
                type="button"
                class="btn btn-sm btn-secondary mr-1"
                @click="verFormImagen = !verFormImagen">
                Cancelar
              </button>
              <button type="submit" class="btn btn-sm btn-primary" :disabled="btnGuardar">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="btnGuardar"
                ></span>
                <span v-else>
                  {{ btnGuardar ? 'Guardando...':'Guardar' }}
                </span>
              </button>
            </div>
          </div>
        </form>
        <hr>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="nav-link active" id="galeria-tab" data-toggle="tab" href="#galeria" role="tab" aria-controls="galeria" aria-selected="true">Galería</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="detalle-tab" data-toggle="tab" href="#detalle" role="tab" aria-controls="detalle" aria-selected="false">Detalle</a>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="galeria" role="tabpanel" aria-labelledby="galeria-tab">
            <div id="carouselExampleIndicators"
              class="carousel slide bg-dark"
              data-ride="carousel">
              <ol class="carousel-indicators">
                <li v-for="(i,indx) in listaImagenes"
                  :key="i.id"
                  data-target="#carouselExampleIndicators"
                  :data-slide-to="indx"
                  :class="indx == 0 ? 'active':''"
                ></li>
              </ol>
              <div class="carousel-inner">
                <div v-for="(i,indx) in listaImagenes"
                  :key="i.id"
                  class="carousel-item text-center"
                  :class="indx == 0 ? 'active':''">
                  <img :src="UrlImgDrive+i.drive_id"
                    class="w-25"
                    :alt="i.carta_producto_id">
                </div>
                <a class="carousel-control-prev"
                  href="#carouselExampleIndicators"
                  role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next"
                  href="#carouselExampleIndicators"
                  role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">Next</span>
                </a>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="detalle" role="tabpanel" aria-labelledby="detalle-tab">
            <div class="table-responsive">
              <table class="table table-sm table-bordered table-condensed table-hover">
                <thead>
                  <tr class="thead-light">
                    <th>Imágen</th>
                    <th>Fecha</th>
                    <th width="100px;">
                      <button type="button" class="btn btn-sm btn-danger btn-border" @click="anularImagen()" :disabled="btnImagen">
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                          v-if="btnImagen"
                        ></span>
                        <span v-else>
                          Anular
                        </span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody v-if="listaImagenes">
                  <tr v-for="i in listaImagenes" :key="i.id">
                    <td>
                      <img v-if="i.drive_id" height="50px" :src="UrlImgDrive+i.drive_id" :alt="'Foto '+i.drive_id">
                    </td>
                    <td>{{ i.fecha }}</td>
                    <td class="text-center">
                      <input type="checkbox" v-model="anularImg" :value="i.id">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <form v-else @submit.prevent="guardar">
        <div class="form-group row mb-1">
          <label for="inputNombre" class="col-sm-2 col-form-label">Nombre:</label>
          <div class="col-sm-4">
            <input
            type="text"
            v-model="form.nombre"
            class="form-control form-control-sm"
            :required="true"
            id="inputNombre"
            >
          </div>
          <label for="inputCodigo" class="col-sm-2 col-form-label">Código:</label>
          <div class="col-sm-4">
            <input
            type="text"
            v-model="form.codigo"
            class="form-control form-control-sm"
            id="inputCodigo"
            >
          </div>
        </div>
        <div class="form-group row mb-1">
          <label for="inputPrecio" class="col-sm-2 col-form-label">Precio:</label>
          <div class="col-sm-4">
            <input
            type="number"
            step="0.01"
            v-model="form.precio"
            :required="true"
            class="form-control form-control-sm"
            id="inputPrecio"
            >
          </div>
          <label for="inputDescripcion" class="col-sm-2 col-form-label">Descripción:</label>
          <div class="col-sm-4">
            <input
            type="text"
            v-model="form.descripcion"
            class="form-control form-control-sm"
            id="inputDescripcion"
            >
          </div>
        </div>
        <div class="form-group row mb-1">
          <label for="selectCategoria" class="col-sm-2 col-form-label">Categoria:</label>
          <div class="col-sm-4">
            <select id="selectCategoria" class="form-control form-control-sm" v-model="form.carta_categoria_id" :required="true">
              <option v-for="i in catalogo.categoria" :value="i.id" :key="i.id">{{ i.descripcion }}</option>
            </select>
          </div>
          <div class="offset-sm-2 col-sm-2">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="inputVisible"
                v-model="form.visible"
                true-value="1"
                false-value="0">
              <label class="form-check-label" for="inputVisible">
                Visible
              </label>
            </div>
          </div>
        </div>
        <div class="form-group row mb-1">
          <label for="selectVisibilidad" class="col-sm-2 col-form-label">Mostrar en:</label>
          <div class="col-sm-4">
            <select id="selectVisibilidad" class="form-control form-control-sm" v-model="form.carta_visibilidad_id" :required="true">
              <option v-for="i in catalogo.visibilidad" :value="i.id" :key="i.id">{{ i.descripcion }}</option>
            </select>
          </div>
        </div>
        <div class="form-group row mb-1">
          <template v-if="form.contenedor == 1">
            <label for="inputCantidadKit" class="col-sm-2 col-form-label">Cantidad KIT:</label>
            <div class="col-sm-4">
              <input
              type="number"
              placeholder="Cantidad de productos para KIT"
              v-model="form.contenedor_cantidad"
              class="form-control form-control-sm"
              :required="true"
              id="inputCantidadKit"
              >
            </div>
          </template>
          <div class="text-right"
          :class="form.contenedor == 1 ? 'col-sm-6':'col-sm-12'">
            <button
              type="button"
              class="btn btn-sm btn-secondary mr-1"
              v-if="reg !== ''"
              @click.prevent="limpiar"
            >
              Nuevo
            </button>
            <button type="button" class="btn btn-sm btn-info mr-1" data-toggle="modal" data-target="#modalImportarImg">
              Importar imágenes
            </button>
            <button type="button" class="btn btn-sm btn-success mr-1" data-toggle="modal" data-target="#modalImportar">
              Importar
            </button>
            <button type="submit" class="btn btn-sm btn-primary" :disabled="btnGuardar">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                v-if="btnGuardar"
              ></span>
              <span class="sr-only" v-if="btnGuardar">
                {{ reg === '' ? 'Guardando...':'Actualizando...' }}
              </span>
              <span v-if="!btnGuardar">
                {{ reg === '' ? 'Guardar':'Actualizar' }}
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer text-muted p-1">
      <form @submit.prevent="buscarProducto">
        <div class="input-group input-group-sm mb-0">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <input 
                type="checkbox" 
                v-model="bform.sinimagen"
                aria-label="Checkbox for following text input" 
                title="Sin imagen"
              >
            </div>
          </div>
          <select class="form-control" v-model="bform.categoria_principal">
            <option :value="null">Categoría/Proveedor</option>
            <option 
              v-for="i in categoriaPrincipal" 
              :key="i.id" 
              :value="i.id"
            >{{ i.descripcion }}</option>
          </select>
          <select class="form-control" v-model="bform.categoria">
            <option :value="null">Subcategoría</option>
            <option 
              v-for="i in subCategoria" 
              :key="i.id" 
              :value="i.id"
            >{{ i.descripcion }}</option>
          </select>
          <input 
            type="text" 
            class="form-control" 
            v-model="bform.nombre"
            placeholder="Buscar por nombre" 
            aria-label="Buscar por nombre" 
            aria-describedby="btnFormBuscar"
          >
          <div class="input-group-append">
            <button 
              class="btn btn-outline-secondary px-3" 
              type="submit" 
              id="btnFormBuscar"
              title="Buscar" 
              :disabled="btnBuscar"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                v-if="btnBuscar"
              ></span>
              <font-awesome-icon icon="search" v-else/>
            </button>
            <button 
              class="btn btn-outline-danger px-3" 
              type="button" 
              id="btnCancelarEdicion"
              title="Cancelar edición" 
              v-if="filaEditar"
              @click="filaEditar = false"
            >
              <font-awesome-icon icon="times"/>
            </button>
            <button 
              class="btn px-3"
              :class="filaEditar ? 'btn-outline-success':'btn-outline-secondary'"
              type="button" 
              id="btnEditar"
              :title="filaEditar ? 'Guardar cambios':'Editar registros'"
              @click="editarFilas"
            >
              <template v-if="btnGuardar">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </template>
              <template v-else>
                <font-awesome-icon icon="save" v-if="filaEditar"/>
                <font-awesome-icon icon="edit" v-else/>
              </template>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="table-responsive" v-if="lista.length > 0">
      <table class="table table-sm mb-0">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Nombre</th>
            <th scope="col">Código</th>
            <th scope="col" class="text-right">Precio</th>
            <template v-if="!filaEditar">
              <th scope="col">Descripción</th>
              <th scope="col">Categoria</th>
              <th scope="col">Fecha</th>
              <th scope="col">Galería</th>
              <th class="text-center">
                <button class="btn btn-sm btn-danger"
                  title="Anular productos"
                  v-if="anular.length > 0"
                  :disabled="btnAnular"
                  @click="anularProducto">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    v-if="btnAnular"
                  ></span>
                  <font-awesome-icon v-else icon="times" />
                </button>
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(i, idx) in filtrada" :key="i.id">
            <th scope="row">{{ idx + 1 }}</th>
            <td>
                <input type="text" v-model="i.nombre" v-if="filaEditar">
                <a href="#formPro" @click="editar(idx)" v-else>{{ i.nombre }}</a>
                <div v-if="i.uimagen == 'TEMP'" title="Nombre de la imagen temporal">
                  <span class="badge badge-secondary">{{ i.nimagen }}</span>
                </div>
            </td>
            <td>
              <input type="text" v-model="i.codigo" v-if="filaEditar">
              <template v-else>{{ i.codigo }}</template>
            </td>
            <td class="text-right">
              <input type="text" v-model="i.precio" v-if="filaEditar">
              <template v-else>{{ i.precio }}</template>
            </td>
            <template v-if="!filaEditar">
              <td>{{ i.descripcion }}</td>
              <td>{{ i.ncategoria }}</td>
              <td>{{ i.fecha }}</td>
              <td>
                <button 
                  class="btn btn-sm btn-light border" 
                  @click="getImagenes(i)"
                  :title="i.nimagen"
                >
                  <font-awesome-icon icon="images" />
                </button>
              </td>
              <td class="text-center">
                <input type="checkbox" v-model="anular" :value="i.id">
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal fade" id="modalImportar" tabindex="-1" role="dialog" aria-labelledby="modalImportarLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <form @submit.prevent="leerXls">
            <div class="modal-header">
              <h5 class="modal-title" id="modalImportarLabel">Subir productos</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <div class="row">
                  <div class="col-6">
                    <label for="imp-de">De:</label>
                    <input type="number" class="form-control" id="imp-de" placeholder="De" v-model="formImportar.de" required step="1" min="1">
                  </div>
                  <div class="col-6">
                    <label for="imp-a">A:</label>
                    <input type="number" class="form-control" id="imp-a" placeholder="A" v-model="formImportar.a" required step="1" min="1">
                  </div>
                </div>
              </div>
              
              
              <div class="form-group">
                <label for="imp-file">Archivo</label>
                <input type="file" class="form-control-file" id="imp-hasta" @change="cambioArchivo" required>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
              <button type="submit" class="btn btn-primary" :disabled="btnImportar">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="btnImportar"
                ></span>
                <span v-else>
                  {{ btnImportar ? 'Guardando...':'Guardar' }}
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalImportarImg" tabindex="-1" role="dialog" aria-labelledby="modalImportarLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <form @submit.prevent="cargarImagenes">
            <div class="modal-header">
              <h5 class="modal-title" id="modalImportarLabel">Subir Imágenes</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row form-group mb-2">
                <div class="col-sm-12">
                  <label for="categoriax">Categoría:</label>
                  <select id="categoriax" class="form-control form-control-sm" name="categoria" :required="true">
                    <option value="">----------</option>
                    <option v-for="i in catalogo.categoria" :key="i.id" :value="i.id">{{ i.descripcion }}</option>
                  </select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-12">
                  <label for="imp-filex">Archivo</label>
                  <input type="file" id="imp-filex" class="form-control-file" name="img_archivo[]" multiple :required="true">
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
              <button type="submit" class="btn btn-primary" :disabled="btnImportar">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="btnImportar"
                ></span>
                <span v-else>
                  {{ btnImportar ? 'Guardando...':'Guardar' }}
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import CartaCatalogo from '../mixins/CartaCatalogo.js';
import ManteAccion from '../mixins/ManteAccion.js';
import XLSX from 'xlsx';

export default {
  name: 'ManteCartaProducto',
  mixins: [CartaCatalogo,ManteAccion],
  data: () => ({
    titulo: 'Productos',
    verFormImagen: false,
    listaImagenes: [],
    producto: {},
    imagen: null,
    principal: 0,
    btnAnular: false,
    anular: [],
    anularImg: [],
    idImagen: null,
    btnImagen: false,
    modalImportar: true,
    btnImportar: false,
    formImportar: {},
    datosXls: [],
    bform: {
      categoria_principal: null,
      categoria: null,
      sinimagen: false,
      nombre: ''
    },
    filaEditar: false
  }),
  created () {
    this.autoBuscar = false;
    this.nombre = 'producto';
    this.listaFiltrar = 'nombre';
    this.getCatalogo(['categoria', 'visibilidad']);
    this.form.visible = 1;
  },
  methods: {
    async editarFilas () {
      this.filaEditar = !this.filaEditar

      if (!this.filaEditar) {
        this.btnGuardar = true
        for (var i = this.filtrada.length - 1; i >= 0; i--) {
          const item = this.filtrada[i]
          await axios.post(this.UrlBase+'/mante/set_'+this.nombre+'/'+item.id, item)
        }
        this.btnGuardar = false
      }
    },
    setImagen (e) {
      this.imagen = e.target.files[0];
    },
    getImagenes(pro) {
      this.verFormImagen = true;
      this.producto = pro;

      axios
      .get(this.UrlBase+'/catalogo/get_imagen/'+pro.id)
      .then(res => {
        this.listaImagenes = res.data.lista;
      }).catch(e => {
        alert('Error Imagen '+e);
      });
    },
    guardarImagen() {
      if (this.imagen && this.producto) {

        let size = parseFloat(this.imagen.size/1024);
        if (size > 1024) {
          this.showWarnMsg({
            message: "El tamaño de la imágen excede a 1 MB, intente de nuevo."
          });
          return false;
        }

        this.btnGuardar = true;

        let datos = new FormData();
        datos.append('archivo', this.imagen);
        datos.append('principal', this.principal);

        axios
        .post(this.UrlBase+'/mante/set_imagen/'+this.producto.id, datos)
        .then(res => {
          this.btnGuardar = false;
          let mensaje = res.data.mensaje;
          if (res.data.exito) {
            this.showSuccessMsg({message: mensaje});
            this.imagen    = null;
            this.principal = 0;
            this.getImagenes(this.producto);
          } else {
            this.showErrorMsg({message: mensaje});
          }
        }).catch(e => {
          this.btnGuardar = false;
          alert('Imagen '+e);
        });
      } else {
        this.showErrorMsg({
          message: "Seleccione una imágen."
        });
      }
    },
    anularProducto () {
      if (confirm('¿Está seguro?')) {
        this.btnAnular = true;

        axios
        .post(this.UrlBase+'/anular/producto', {productos: this.anular})
        .then(res => {
          if (res.data.exito) {
            this.verFormImagen = false;
            this.producto = {};
            this.anular = [];
            this.limpiar();
            this.buscar();
          } else {
            this.showErrorMsg({message: res.data.mensaje});
          }
          this.btnAnular = false;
        }).catch(e => {
          this.btnAnular = false;
          alert("Anular "+e);
        })
      }
    },
    anularImagen () {
      if (this.anularImg.length == 0) {
        this.showErrorMsg({
          message: "Seleccione una imágen para continuar."
        });
        return false;
      }

      if (confirm("¿Está seguro?")) {
        this.btnImagen = true;

        axios
        .post(this.UrlBase+'/anular/imagen', {imagenes: this.anularImg})
        .then(res => {
          if (res.data.exito) {
            this.anularImg = [];
            this.getImagenes(this.producto);
          } else {
            this.showErrorMsg({message: res.data.mensaje});
          }
          this.btnImagen = false;
        }).catch(e => {
          alert('Anular img '+e);
        })
      }
    },
    cambioArchivo(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
      return;
      this.formImportar.archivo = files[0];
    },
    leerXls() {
      let f = this.formImportar.archivo;
      let reader = new FileReader();
      let self = this

      reader.onload = function(e) {
        let results, 
            data = e.target.result, 
            fixedData = self.fixdata(data), 
            workbook=XLSX.read(btoa(fixedData), {type: 'base64'}), 
            firstSheetName = workbook.SheetNames[0], 
            worksheet = workbook.Sheets[firstSheetName];
        results = XLSX.utils.sheet_to_json(worksheet, {header:1});
        self.datosXls = results
        self.guardarXls();
      };
      reader.readAsArrayBuffer(f);
    },
    fixdata(data) {
      let o = "", l = 0, w = 10240;
      for(; l<data.byteLength/w; ++l) {
        o+= String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l*w,l*w+w))
        );
      }

      o += String.fromCharCode.apply(
        null,
        new Uint8Array(data.slice(l*w))
      );

      return o;
    },
    guardarXls() {
      this.formImportar.registros = this.xlsJson;
      this.btnImportar = true;
      axios
      .post(this.UrlBase+'/mante/set_producto_xls', this.formImportar)
      .then(r => {
        if (r.data.exito) {
          this.showSuccessMsg({message: r.data.mensaje});
          if (r.data.linea) {
            r.data.linea.forEach((linea) => {
              this.lista.push(linea);
            })
          }
          this.formImportar = {};
          this.datosXls = [];
          this.formImportar.archivo = null
        } else {
          this.showWarnMsg({message: r.data.mensaje});
        }
      })
      .catch(e => {
        this.showErrorMsg({message: e});
      }).finally(() => {
        this.btnImportar = false;
      });
    },
    cargarImagenes (e) {
      if (confirm('¿Está seguro?')) {
        this.btnImportar = true;
        let datos = new FormData(e.target);

        axios
        .post(`${this.UrlBase}/mante/set_imagen_producto`, datos)
        .then(res => {
          if (res.data.exito) {
            e.target.reset();
            if (res.data.exito == 1) {
              this.showSuccessMsg({message: res.data.mensaje});
            }
            if (res.data.exito == 2) {
              this.showInfoMsg({message: res.data.mensaje});
            }
          } else {
            this.showErrorMsg({message: res.data.mensaje});
          }
          this.btnImportar = false;
        }).catch(e => {
          this.btnImportar = false;
          alert('Error '+e);
        })
      }
    },
    buscarProducto () {
      this.btnBuscar = true;
      let busqueda = this.bform.categoria_principal === null 
      && this.bform.categoria === null
      && !this.bform.sinimagen
      && this.bform.nombre === '';
      
      if (busqueda) {
        alert('Por favor ingrese un criterio de búsqueda');
        this.btnBuscar = false;
      } else {
        axios
        .get(this.UrlBase + '/catalogo/get_producto', {params: this.bform})
        .then(r => {
          this.lista = r.data.lista;
          this.btnBuscar = false;
        })
        .catch(e => {
          alert(e);
          this.btnBuscar = false;
        });
      }
    }
  },
  watch: {
    reg () {
      this.verFormImagen = false;
      this.producto = {};
    },
    'form.contenedor' (valor) {
      if (valor == 0) {
        this.form.contenedor_cantidad = 0;
      }
    }
  },
  computed: {
    xlsJson() {
      let tmp = [];
      this.datosXls.forEach((el, index) => {
        if (
          index >= this.formImportar.de-1 &&
          index <= this.formImportar.a-1
        ){
          let aux = {
            categoria: el[0],
            nombre: el[2],
            codigo: el[3],
            precio: el[4],
            descripcion: el[5]
          };

          if (el[1]) aux.subcategoria= el[1];
          if (el[6]) {
            aux.imagen1 = {
              name: el[6],
              tmp_name: 'C://categoria_principal/'+el[6],
            }

          }
          if (el[7]) {
            aux.imagen2 = {
              name: el[7],
              tmp_name: 'C://categoria_principal/'+el[7],
            }

          }
          if (el[8]) {
            aux.imagen3 = {
              name: el[8],
              tmp_name: 'C://categoria_principal/'+el[8],
            }

          }

          tmp.push(aux);
        }
      })
      return tmp;
    },
    categoriaPrincipal () {
      return this.catalogo.categoria.filter(obj => {
        return obj.carta_categoria_id === null
      })
    },
    subCategoria () {
      return this.catalogo.categoria.filter(obj => {
        return (obj.carta_categoria_id !== null && obj.carta_categoria_id === this.bform.categoria_principal)
      })
    }
  }
}
</script>